<template>
  <vz-html2pdf
    ref="html2Pdf"
    pdf-content-width="100%"
    :float-layout="false"
    :pdf-quality="2"
    :html-to-pdf-options="htmlToPdfOptions"
    :manual-pagination="true"
    :filename="filename"
    @hasDownloaded="generated"
  >
    <slot />
  </vz-html2pdf>
</template>

<script setup lang="ts">
import VzHtml2pdf from '~/components/ui-kit/vz-html2pdf.vue';
const widthToHeightAspect = 1.414

const emit = defineEmits(['generated'])
const props = defineProps({
    filename: {
        default: 'pdf',
        type: String
    },
    windowWidth: {
        default: 1600,
        type: Number
    },
    documentWidth: {
        default: 880,
        type: Number
    },
    pdfWidth: {
        default: 1600,
        type: [Number]
    }
})

defineExpose({
    generatePdf
})

const html2Pdf = ref()

const settings = ref({
    windowWidth: props.windowWidth,
    pdfOrientation: 'p',
    documentWidth: props.documentWidth,
    pdfWidth: props.pdfWidth
})
const htmlToPdfOptions = ref({
    filename: props.filename,
    jsPDF: {
        orientation: settings.value.pdfOrientation,
        unit: 'px',
        format: 'a4',
        // hotfixes: ['px_scaling'],
    },
    html2canvas: {
        windowWidth: settings.value.windowWidth,
        width: settings.value.pdfWidth,
        scale: 2,
        onclone: onClone
    }
})

function generated(e: any) {
    emit('generated')
}

function onClone(_: HTMLDocument, element: HTMLElement): void {
    // Параметры видимой страницы
    const width = settings.value.documentWidth
    const height = width * widthToHeightAspect
    // Высота виртуальной страницы
    const pageHeight = settings.value.pdfWidth * widthToHeightAspect
    // Заполненость страницы контентом
    let currentHeight = 0

    const sections: HTMLElement[] = Array.from(element.querySelectorAll('.pdf-order-section'))
    element.classList.add('pdf-order-container')
    element.style.width = `${width}px`

    for (const i in sections) {
        const sectionHeight = sections[i].offsetHeight
        const bottom = sectionHeight + currentHeight

        if (!sectionHeight) {
            continue
        }

        if ((bottom > height) && +i > 0) {
            sections[(+i) - 1].style.marginBottom = `${pageHeight - currentHeight}px`
            currentHeight = 0
        }
        currentHeight += sectionHeight
    }
}

function generatePdf(): void {
    return html2Pdf.value?.generatePdf()
}
</script>
